import React from "react";
import style from "css/landing.module.css";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

function SpaceItem(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  return (
    <>
      {
        props.tech.isActive
          ? (
            <Link
              to={`${process.env.REACT_APP_CLIENT_URL + props.tech.link}`}
              className={`${style.technology_list_item} ${style[props.type]}`}
              style={{
                backgroundImage:
                  !isMobile && !isTablet
                    ? `url('${process.env.REACT_APP_CLIENT_URL + props.tech.img}')`
                    : `url('${process.env.REACT_APP_CLIENT_URL + props.tech.img_m}')`,
              }}
            >
              <div className={style.technology_list_item_text_wrap}>
                <div className={style.technology_list_item_label}>
                  {props.tech.label}
                </div>
                <div
                  className={style.technology_list_item_title}
                  dangerouslySetInnerHTML={{ __html: props.tech.title }}
                ></div>
                <div className={style.technology_list_item_text}>{props.tech.text}</div>
              </div>
            </Link>
          )
          :
          isMobile || isTablet
            ? <></>
            :
            <div
              className={`${style.technology_list_item} ${style[props.type]} ${style.disabled}`}
              style={{
                backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL + props.tech.img}')`
              }}
            >
              <article className={style.disabled_overlay}>
                <p>곧 공개 예정</p>
                <p>새로운 페이지가 곧 찾아옵니다.</p>
              </article>
            </div>
      }
    </>
  );
}

export default SpaceItem;
